// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"175":"4b68e092b0bdd3ad","854":"d35bbd4e61ccdc60","885":"ca3f10bc93164380"}[chunkId] + ".js";
};